
export const publicRoutesPath = {
    LOGIN: "/",
    SIGNUP: "/signup",
    FORGOTPASSWORD: "/forgot-password",
    FIRST_USER_PASSWORD_SETUP: "/set-user-password"
}

export const privateRoutesPath = {
    BIZTANTU: '/biztantu',
    DASHBOARD: '/biztantu/dashboard',
    LEADS: '/biztantu/leads',
    CUSTOMER: '/biztantu/customer',
    MERCHANT: '/biztantu/merchant',
    PRODUCT: '/biztantu/product',
    CONFIGURATION: '/biztantu/configuration',
    CREATE_LEAD: '/biztantu/leads/create-lead',
    EDIT_LEAD: `/biztantu/leads/edit-lead`,
    LEAD_BULK_UPLOAD: '/biztantu/leads/bulk-upload',

    CREATE_PRODUCT: '/biztantu/product/create-product',
    PRODUCT_BULK_UPLOAD: '/biztantu/product/bulk-upload',
    EDIT_PRODUCT: `/biztantu/product/edit-product`,

    CREATE_MERCHANT: '/biztantu/merchant/create-merchant',
    EDIT_MERCHANT: `/biztantu/merchant/edit-merchant`,
    MERCHANT_BULK_UPLOAD: '/biztantu/merchant/bulk-upload',

    CREATE_CUSTOMER: '/biztantu/customer/create-customer',
    EDIT_CUSTOMER: `/biztantu/customer/edit-customer`,
    CUSTOMER_BULK_UPLOAD: '/biztantu/customer/bulk-upload',

    INVOICE: '/biztantu/invoice',
    CREATE_INVOICE:`/biztantu/invoice/create-invoice`,
    EDIT_INVOICE: '/biztantu/invoice/edit-invoice',

    ORDER: '/biztantu/order',
    VIEW_ORDER: '/biztantu/order/edit-order',
    CREATE_ORDER: '/biztantu/order/create-order',

    LEAD_BULK_UPLOAD_MAPPING: '/biztantu/leads/bulk-upload/mapping',
    GLOBAL_SEARCH: '/biztantu/global-search',
    BIZTANTU_CAMPAIGN: "/biztantu/campaign",
    CREATE_CAMPAIGN: "/biztantu/campaign/create-campaign",
    EDIT_CAMPAIGN: "/biztantu/campaign/edit-campaign",
    REQUEST_CAMPAIGN: "/biztantu/request-campaign",

    CREATE_TEMPLATE: "/biztantu/template/create-template",
    BIZTANTU_TEMPLATE: "/biztantu/template",
    EDIT_TEMPLATE: "/biztantu/template/edit-template",
    SEND_EXTERNAL_EMAIL: "/biztantu/campaign/send-external-email",

    BIZTANTU_AUDIT: "/biztantu/audit",
    PROFILE: "/biztantu/profile"

    
    

} 